import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet-async";

import HeroSection from "./HeroSection";
import "./home.css";

// const CustomerSection = lazy(() => import("./CustomerSection"));
// const Testimonial = lazy(() => import("./Testimonial"));
const CounterSection = lazy(() => import("./CounterSection"));
const WhoWeAreSection = lazy(() => import("./WhoWeAreSection"));
const DomainServed = lazy(() => import("./DomainServed"));
const RoadmapSection = lazy(() => import("./RoadmapSection"))
const HomeFAQ = lazy(() => import("./HomeFAQ"));
const CostBeneftsSection = lazy(() => import("./CostBeneftsSection"));
const KeyPointsSection = lazy(() => import("./KeyPointsSection"));



const Home = () => {
  return (
    <>
     <Helmet>
  <title>
    Winglo | Cloud-Based Healthcare & Education Software Solutions
  </title>

  <meta
    name="description"
    content="Winglo delivers cloud-based software solutions for Healthcare and Education domains, including enterprise-grade LIMS platforms for individual labs and multi-center diagnostic chains."
  />

  <meta
    name="keywords"
    content="Winglo, healthcare software, education software, LIMS software, laboratory management system, cloud-based LIMS, diagnostic lab software, healthcare IT solutions, education management system, enterprise software, Chennai IT company"
  />
</Helmet>


      <HeroSection />

      <Suspense fallback={<div aria-busy="true" className="h-[400px]" />}>
        
        <CounterSection />
        <DomainServed />
        <RoadmapSection />
        <WhoWeAreSection />
        <CostBeneftsSection />
        {/* <CustomerSection />
        <Testimonial />  */}
        <KeyPointsSection />
        <HomeFAQ />
      </Suspense>
    </>
  );
};


export default Home;
